import browse from './browse.vue';
import form from './form.vue';
import read from './read.vue';
import securables from './securables';
import translations from './translations';

export default { browse, create: form, read, edit: form, securables, translations };
